/*
 * File: AddIconBox.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles that Diagnosis and Provider cards on the Billing Order view.
 */
import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const styles = theme => ({
  addButton: {
    position: "absolute",
    right: theme.spacing(-0.5),
    top: theme.spacing(2.25),
    zIndex: 999
  },
  sectionType: {
    padding: theme.spacing(2.5),
    float: "left",
    marginLeft: theme.spacing(-0.5),
    fontWeight: [400],
    color: theme.palette.common.title
  }
});

const AddIconBox = ({ classes, disabled, label, addIconOnClick }) => {
  let onClick = () => {
    addIconOnClick();
  };
  let id = label + "-add-icon";
  return (
    <div>
      <Typography variant="h5" className={classes.sectionType}>
        {label}
      </Typography>

      <Button
        id={id}
        color="primary"
        className={classes.addButton}
        onClick={onClick}
        disabled={disabled || false}
      >
        <AddIcon />
      </Button>
    </div>
  );
};

AddIconBox.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  addIconOnClick: PropTypes.func.isRequired
};

export default withStyles(styles)(AddIconBox);
